import { render, staticRenderFns } from "./News.vue?vue&type=template&id=c291d8aa&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/news.scss?vue&type=style&index=0&id=c291d8aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291d8aa",
  null
  
)

export default component.exports